// extracted by mini-css-extract-plugin
export var articleContents = "Article-module--articleContents--1Z85L";
export var anchoredHeading = "Article-module--anchoredHeading--2gBCt";
export var coreList = "Article-module--coreList--pOimE";
export var articleBlocks = "Article-module--articleBlocks--2xFOa";
export var sectionOuterMarginTop = "Article-module--sectionOuterMarginTop--29Yjz";
export var noSpacingBelow = "Article-module--noSpacingBelow--iZ-wg";
export var coreHTMLBlock = "Article-module--coreHTMLBlock--3iF7y";
export var articleCoreTable = "Article-module--articleCoreTable--253TW";